import React, {useEffect, useRef} from 'react';
import {AppState, AppStateStatus} from 'react-native';
import {noop} from 'lodash';

import RecordsScreen from '/component/layout/RecordsScreen';
import {useTranslation} from '/provider/TranslationProvider';

import {AllCandidatesContent} from './AllCandidatesContent';
import reportPayload from './reportPayload';

interface AllCandidatesReportProps {
  resetCandidatesData: () => void;
  loadingData: {
    total?: number;
  };
}

export const AllCandidatesReport: React.FC<AllCandidatesReportProps> = ({
  resetCandidatesData = noop,
  loadingData = {},
  ...props
}) => {
  const {ts} = useTranslation('report.allCandidates');
  const appState = useRef<AppStateStatus>(AppState.currentState);

  useEffect(() => {
    const subscription = AppState.addEventListener('change', nextAppState => {
      if (
        appState.current.match(/inactive|background/) &&
        nextAppState === 'active'
      ) {
        resetCandidatesData();
      }

      appState.current = nextAppState;
    });

    return () => {
      subscription.remove();
    };
  }, [resetCandidatesData]);

  return (
    <RecordsScreen
      {...reportPayload}
      contentComponent={AllCandidatesContent}
      title={ts('title', 'All Candidates')}
      isTopLineTitle={true}
      showFeedback={true}
      showAddCandidateButton={true}
      contentProps={{loadingData}}
      {...props}
    />
  );
};
